function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "back-arrow-b",
  width: 48,
  height: 48,
  y: .27
}), React.createElement("filter", {
  id: "back-arrow-a",
  width: "141.7%",
  height: "141.7%",
  x: "-20.8%",
  y: "-16.7%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 4,
  result: "shadowInner"
}), React.createElement("feOffset", {
  dy: 2,
  in: "shadowInner",
  result: "shadowInner"
}), React.createElement("feComposite", {
  in: "shadowOffsetOuter1",
  in2: "shadowInner",
  operator: "out",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 3
}), React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0.0352941176   0 0 0 0 0.0588235294   0 0 0 0 0.0980392157  0 0 0 0.4 0"
})), React.createElement("filter", {
  id: "back-arrow-c",
  width: "587.5%",
  height: "325%",
  x: "-262.5%",
  y: "-112.5%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 3
}), React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0.0352941176   0 0 0 0 0.0588235294   0 0 0 0 0.0980392157  0 0 0 0.4 0"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#back-arrow-a)",
  xlinkHref: "#back-arrow-b"
}), React.createElement("rect", {
  width: 44,
  height: 44,
  x: 2,
  y: 2.27,
  stroke: "#FFF",
  strokeLinejoin: "square",
  strokeWidth: 4
}), React.createElement("polyline", {
  stroke: "#FFF",
  strokeWidth: 6,
  points: "7.635 15.539 0 7.904 7.635 .27",
  filter: "url(#back-arrow-c)",
  transform: "translate(20 16)"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 49,
    viewBox: "0 0 48 49"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/backArrow.3a59eb13.svg";
export { SvgComponent as ReactComponent };